import React from 'react';
import { ExternalLink, Menu } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';

import { PurchaseOrderActionsMenu } from './PurchaseOrderActionsMenu';

/**
 * Renders action buttons for a purchase order table row.
 *
 * @param {Object} props - Component props.
 * @param {() => void} [props.onViewClick] - Optional callback when the view button is clicked.
 * @param {() => void} [props.onDuplicate] - Optional callback when duplicate is clicked.
 * @param {() => void} [props.onDownloadCsv] - Optional callback when CSV download is clicked.
 * @param {() => void} [props.onDownloadPdf] - Optional callback when PDF download is clicked.
 * @param {() => void} [props.onDownloadShipList] - Optional callback when Ship-List download is clicked.
 * @param {() => void} [props.onSendToVendor] - Optional callback when send to vendor is clicked.
 * @param {() => void} [props.onCancel] - Optional callback when cancel is clicked.
 * @param {boolean} [props.isSendToVendorDisabled] - Whether send to vendor is disabled.
 * @param {string} [props.lastSentAt] - Optional last sent timestamp.
 * @returns {JSX.Element} Actions cell JSX.
 */
export function PurchaseOrderActionsCell({
    isSendToVendorDisabled,
    lastSentAt,
    onCancel,
    onDownloadCsv,
    onDownloadPdf,
    onDownloadShipList,
    onDuplicate,
    onSendToVendor,
    onViewClick,
}) {
    return (
        <div className="flex items-center gap-2">
            <Button variant="ghost" size="icon" aria-label="View purchase order" onClick={onViewClick}>
                <ExternalLink className="h-4 w-4" />
            </Button>
            <PurchaseOrderActionsMenu
                onDuplicate={onDuplicate}
                onDownloadCsv={onDownloadCsv}
                onDownloadPdf={onDownloadPdf}
                onDownloadShipList={onDownloadShipList}
                onSendToVendor={onSendToVendor}
                onCancel={onCancel}
                lastSentAt={lastSentAt}
                isSendToVendorDisabled={isSendToVendorDisabled}
            />
        </div>
    );
}
